/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * External organization (insurance company, contracting company, etc.)
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {number}
     * @memberof Organization
     */
    readonly id: number;
    /**
     * PA firm that owns this record
     * @type {number}
     * @memberof Organization
     */
    companyId: number;
    /**
     * Free-form organization type (e.g. insurance_company, contracting_company)
     * @type {string}
     * @memberof Organization
     */
    orgType: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    address?: string | null;
    /**
     * Must be a fully-qualified URL starting with http:// or https://
     * @type {string}
     * @memberof Organization
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Organization
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof Organization
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Organization
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Organization interface.
 */
export function instanceOfOrganization(value: object): value is Organization {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgType' in value) || value['orgType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OrganizationFromJSON(json: any): Organization {
    return OrganizationFromJSONTyped(json, false);
}

export function OrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'orgType': json['orgType'],
        'name': json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'address': json['address'] == null ? undefined : json['address'],
        'website': json['website'] == null ? undefined : json['website'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function OrganizationToJSON(json: any): Organization {
    return OrganizationToJSONTyped(json, false);
}

export function OrganizationToJSONTyped(value?: Omit<Organization, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'orgType': value['orgType'],
        'name': value['name'],
        'phone': value['phone'],
        'email': value['email'],
        'address': value['address'],
        'website': value['website'],
        'notes': value['notes'],
        'createdBy': value['createdBy'],
    };
}

